<template>
	<div class="main-content">
		<Nav></Nav>	
		<div class="center-body">
					
			<div class="row banner-box" style="margin-top: 0px;">
				<img src="../../assets/img/u30.jpg" class="banner-img main" />	
				<img src="../../assets/img/u31.jpg" class="banner-img phone" />	
			</div>
			<!--<div class="row banner-box2" style="flex-direction: row-reverse;">
				<img src="../../assets/img/u31.png" class="banner-img2"/>
			</div>-->
			
			<div class="row" style="margin-top: 30px;font-size: 24px;color: #333;font-weight: 600;justify-content: center;align-items: center;background: #fff;padding-top: 20px;">
				<img src="../../assets/img/u12.svg" style="height: 18px;margin-right: 10px;">SINCE 1949
			</div>
			<!--<div class="row" style="font-size: 16px;color: rgb(102, 102, 102);justify-content: center;background: #fff;padding-bottom: 25px;">
				Tomal  Production
			</div>-->
			
			<div class="wrap-row" style="background: #fff;padding: 20px;">				
				<div class="video-text">
					<div class="vb-f">TOMAL</div>
					<div class="vb-s">TOMAL不仅是拥有核心产品的生产商，同时也是系统集成商。</div>
				</div>
				<div class="video-box">
					<video src="http://www.tomal.cn/plmt/bbf0e4458a5b8f043387f6f956b1f172.mp4" style="width: 100%;border-radius: 5px;" controls autoplay muted type="video/mp4"></video>
				</div>
				<div class="video-text2">				
					<div class="vb-s">TOMAL不仅是拥有核心产品的生产商，同时也是系统集成商。</div>
				</div>
			</div>
			<div class="wrap-row between" style="margin-top: 30px;justify-content: center;background: #fff;padding: 20px 10px">
				<div class="col-no phone-m-r" style="align-items: center;">
					<img src="../../assets/img/u20.png" class="img-u20"/>
					<span style="margin-top: 10px;font-size: 15px;">单进单出多螺旋精确计量喂料机</span>
				</div>
				<div class="col-no phone-m-r" style="align-items: center;">
					<img src="../../assets/img/u22.jpg" class="img-u22"/>
					<span style="margin-top: 10px;font-size: 15px;">单进多出多螺旋精确计量喂料机</span>
				</div>
				<div class="col-no" style="align-items: center;">
					<img src="../../assets/img/u21.png" class="img-u21"/>
					<span style="margin-top: 10px;font-size: 15px;">长距离刚性单螺旋输送器</span>
				</div>
				
				
				
			</div>
			
			<div class="row" style="margin-top: 30px;background: #fff;padding: 20px 10px;justify-content: center;">
				<div class="jc-left">
					TOMAL 半个多世纪以来，在各类粉体化学品的处理、各工艺应用、系统集成性等方面积累了丰富的经验，广泛应用于各行各业。<br><span >TOMAL 经营理念</span>- 研发、生产、销售，为客户量身定制交钥匙系统。<br>- 稳定、可靠、高精度。<br>- 全球范围内各行各业的供货、安装以及服务。
				</div>
				<div class="jc-right">
					<img src="../../assets/img/u24.png" class="img-u24" />
				</div>
			</div>
			<div class="row foot-box main" style="margin:0 auto;margin-top: 30px;width: 980px;">			
				<div class="col-no foot-item">
					<!--<span style="color: #fff;font-size: 24px;font-weight: 600;">TOMAL</span>-->
					<span class="foot-text" style="margin-top: 15px;">电话：021－36360298</span>
					<span class="foot-text">地址：上海市闵行区陈行公路2168号8号楼</span>
					<span class="foot-text">邮箱：tomal-china@tomal.se</span>
					<span class="foot-text">网址：www.tomal.cn</span>
				</div>
				<div class="item-no" style="align-items: center;" >
					<img src="../../assets/img/u26.png" style="width: 174px;height: 66px;"/>
				</div>
			</div>
			<div class="col foot-box phone" style="justify-content: center;margin-top: 30px;">
				<!--<div class="row" style="justify-content: center;" >
					<img src="../../assets/img/u26.png" style="width: 174px;height: 66px;"/>
				</div>
				<div style="font-size: 18px;color: #fff;font-weight: 600;text-align: center;margin-top: 25px;">
					TOMAL has core products,<br>
					With complete set of capacity
				</div>-->
				<div class="row" >
					<img src="../../assets/img/u26.png" style="width: 174px;height: 66px;"/>
				</div>
				<div class="col-no foot-item" style="width: 100%;">
					<!--<span style="color: #fff;font-size: 24px;font-weight: 600;">TOMAL</span>-->
					<span class="foot-text" style="margin-top: 15px;">电话：021－36360298</span>
					<span class="foot-text">地址：上海市闵行区陈行公路2168号8号楼</span>
					<span class="foot-text">邮箱：tomal-china@tomal.se</span>
					<span class="foot-text">网址：www.tomal.cn</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
				
			}
		},
		methods: {

		},
		mounted() {

		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		display: block;
		position: absolute;
		background: #F5F5F5;
	}
	.banner-box{
    	overflow: hidden;
    }
    .banner-img{
	    width: 980px;	
	}	
	.between{
    	padding-top: 25px;
    	align-items: center;
    }
    .foot-box{
    	/*height:180px;*/
    	width: 100%;
    	background-color:#123466;
    	justify-content: space-between;
    	padding: 15px;
    }
	@media screen and (max-width: 980px) {
	    .center-body{	    	
	    	width: 100%;
	    	
	    }
	    .main-nav{
	    	display: none;
	    }
	    .banner-img2{
	    	width: 176px;
	    	height: 121px;
	    }
	    .banner-box2{
	    	margin-top: -80px;
	    }
	    .video-text{
	    	display: none;
	    }
	    .video-box{
	    	width:100%;
	    	/*height: 400px;*/
	    	/*background: #999;*/
	    }
	    .video-text2{
	    	margin-top: 5px;
	    	width: 100%;
	    	font-size: 12px;
	    	line-height: 2;
	    	padding:15px;
	    	/*text-indent: 15px;*/
	    }
	     .img-u20{
	    	width:350px
	    }
	    .img-u21{
	    	margin-top: 40px;
	    	width:350px
	    }
	    .img-u22{
	    	margin-top: 40px;
	    	width:350px
	    }
	    .jc-left{
	    	flex: 4;
	    	line-height: 2;
	    	font-size: 12px;
	    	padding: 5px;
	    	flex-direction: column;
			display: flex;
	    	/*text-indent: 15px;*/
	    }
	    .jc-right{
	    	flex: 2;
	    	display: flex;
	    	align-items: center; 
	    	margin-left: 5%;   	
	    }
	    .img-u24{
	    	width: 100%;
	    }
	    .foot-text{
	    	color: #fff;
	    	font-size: 12px;
	    	margin-top: 5px;
	    }
	    .foot-item{
	    	width:170px;
	    }
	    .main{
	    	display: none;
	    }
	}
	@media screen and (min-width: 980px) {
	    .center-body{	    	
	    	width: 980px;
	    	margin: 0 auto;
	    	
	    }
	    .phone-m-r{
	    	margin-right: 50px;
	    }
	    .nav-title{
	    	font-size: 30px;
	    	height: 60px;
	    	padding-top: 10px;
	    	width: 160px;
	    	text-align: center;
	    	border-bottom: 1px solid #dcdee2;
	    	flex: none;
	    	
	    }
	    .nav-right{	    	
	    	height: 60px;
	    	border-bottom: 1px solid #dcdee2;
	    	
	    }
	    .ivu-menu-item{
	    	width: 120px;
	    	text-align: center;
	    }
	    .banner-box2{
	    	margin-top: -125px;
	    }
	    .banner-img2{
	    	width: 317px;
	    	height: 224px;
	    }
	    .video-box{
	    	display: inline-block;
	    	width:525px;
	    	margin: 0 auto;
	    	margin-left: 125px;
	    	/*background: #999;*/
	    }
	    .video-text{
	    	display: inline-block;
	    	width:218px;
	    	height: 285px;
	    	margin-left: 40px;
	    	float: left;
	    }
	    .vb-f{
	    	font-size: 30px;
	    	font-weight: 600;
	    	line-height: 45px;
	    	width: 145px;
	    	border-bottom: 1px solid #cdcdcd;
	    	
	    }
	    .vb-s{
	    	margin-top: 15px;
	    	font-size: 14px;
	    	width: 225px;
	    	line-height: 2;
	    }
	    .video-text2{
	    	display: none;
	    }
	    .img-u20{
	    	width: 214px;
	    	height: 168px;
	    }
	    .img-u21{
	    	
	    	width: 248px;
	    	height: 168px;
	    }
	    .img-u22{
	    	width: 276px;
	    	height: 168px;
	    }
	    .between{
	    	justify-content: space-between;
	    }
	    .jc-left{
	    	width: 546px;
	    	line-height: 2;
	    	font-size: 14px;
	    	flex: none;
	    	flex-direction: column;
	    	justify-content: center;
	    	display: flex;
	    	/*text-indent: 15px;*/
	    }
	    .img-u24{
	    	margin-left: 160px;
	    	height: 327px;
	    }
	    .foot-item{
	    	width: 450px;
	    }
	    .foot-text{
	    	color: #fff;
	    	font-size: 14px;
	    	margin-top: 10px;
	    }
	    .phone{
	    	display: none;
	    }
	}
</style>